/**
 * Unified logout function for the entire application
 * Clears all authentication tokens and user data, then redirects to home
 */
export const handleLogout = () => {
    // Clear all possible auth tokens
    localStorage.removeItem("token");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("customerToken");

    // Clear user data
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    localStorage.removeItem("customerName");
    localStorage.removeItem("customerId");

    // Clear any other session data
    localStorage.removeItem("selectedAddress");
    localStorage.removeItem("cart");
    localStorage.removeItem("cartCount");

    // Trigger global refresh for Contexts
    window.dispatchEvent(new Event("auth-change"));

    // Redirect to home page
    window.location.href = "/";
};

export default handleLogout;
